import { Injectable } from '@angular/core';
import { ApiLoadingService } from './api-loading.service';
import { ApiCallService } from './api-call.service';
import { Reason } from './../models/index';
import { Resolve } from '@angular/router';

@Injectable()
export class ReasonService implements Resolve<Reason[]> {
  constructor(
    private apiLoadingService: ApiLoadingService,
    private apiCallService: ApiCallService
  ) { }

  getReasons(): Promise<Reason[]> {
    return this.apiCallService.get('/reasons');
  }

  resolve(): Promise<Reason[]> {
    const promise = this.getReasons();

    this.apiLoadingService.startLoading(promise);

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/reason.service.ts